/**
 * This class is mainly for typing purposes, since these two properties get replaced with the GandalfModel decorator driven ones.
 */
export abstract class GandalfModelBase {
	$label: any;
	$subRequestLabel: any;
	$validators: any;
	$isRequired: any;
}
